export default "__VITE_ASSET__BdmH8dGr__"